<template>
    <!-- 用户资产 -->
    <div id="agentUserAssets">
        <!-- 头部数据更新时间模块 -->
        <headerUpdate></headerUpdate>
        <b-card class="header-top" ref="headerH">
            <div class="header-page-title">
                <div class="title">
                    {{ currentPageTitle }}
                </div>
            </div>
            <b-row>
                <b-col lg="9">
                    <!--搜索uid-->
                    <b-form-group class="find-middle" :label="$t('lanV4.newUid')">
                        <b-form-input v-model.trim="searchUid" maxLength="10" placeholder=""></b-form-input>
                    </b-form-group>
                    <b-form-group class="find-middle" :label="$t('lanV4.PID')">
                        <b-form-input v-model.trim="pid" maxLength="10" placeholder=""></b-form-input>
                    </b-form-group>
                    <!--返佣级别-->
                    <b-form-group class="find-middle">
                        <label>
                            <el-tooltip placement="top">
                                <div slot="content" :style="{ maxWidth: tipWidth }">
                                    {{ $t("lanV4.ReturnedCommissionLevelTip") }}
                                </div>
                                <span class="el_tooltip_bor">
                                    {{ $t("lanV4.ReturnedCommissionLevel") }}</span>
                            </el-tooltip>
                        </label>
                        <v-select class="find-select" v-model="level" :options="levelArray">
                            <div slot="no-options">{{ $t("common.noFind") }}</div>
                        </v-select>
                    </b-form-group>
                    <!-- 保证金币种 -->
                    <b-form-group :label="$t('lanV4.marginCoin')" class="find-middle">
                        <v-select class="find-select" v-model="symbol" :options="symbolList">
                            <div slot="no-options">{{ $t("common.noFind") }}</div>
                        </v-select>
                    </b-form-group>
                    <!-- 注册时间 -->
                    <b-form-group :label="$t('common.date')" class="find-middle">
                        <el-date-picker v-model="dateArray" unlink-panels value-format="yyyy/MM/dd" type="daterange"
                            range-separator="-" :start-placeholder="$t('common.startDate')"
                            :end-placeholder="$t('common.endDate')" @change="handleChangeDate" :clearable="false"
                            :picker-options="pickerOptions">
                        </el-date-picker>
                    </b-form-group>

                </b-col>
                <b-col lg="3" class="header-right-btn">
                    <div class="find-middle find-btnBox">
                        <b-button variant="primary" @click="query">
                            <!-- <svg class="icon icon-14 icon-search" aria-hidden="true">
                      <use xlink:href="#icon-v4_17"></use>
                    </svg> -->
                            {{ $t("common.search") }}</b-button>
                        <b-button variant="light" @click="reset">
                            <!-- <svg class="icon icon-14 icon-reset" aria-hidden="true">
                      <use xlink:href="#icon-v4_3"></use>
                    </svg> -->
                            {{ $t("common.reset") }}</b-button>
                    </div>
                </b-col>
            </b-row>
            <!-- 头部分割线 -->
            <div class="header-top-bottom-bor"></div>
        </b-card>
        <b-card class="table-card">
            <div slot="header">
                <div class="table-title float-left">
                    <!-- 数据总览 标题 -->
                    <!-- {{ $t("lanV4.Datascreening") }} -->
                    <span v-if="pages.total > 0">
                        {{ $t("el.pagination.total", { total: pages.total }) }}
                    </span>
                </div>
                <!-- <v-page
                class="float-left"
                v-if="pages.total > 0"
                :total-rows="pages.total"
                :perPage="pages.size"
                :pageOptions="pages.options"
                :currentPage="pages.page"
                @initialize="pageChange"
                layout="total,sizes"
              >
              </v-page> -->
                <!-- 导出 -->
                <b-button v-if="pages.total > 0" class="float-right btn-export" variant="light"
                    :class="!isexportIng ? 'lodingSattus' : ''" @click="exports">
                    <svg class="icon icon-16" aria-hidden="true">
                        <use xlink:href="#icon-v4_6_h"></use>
                    </svg>
                    {{ exportButtonText }}
                    <svg v-if="!isexportIng" class="icon icon-20 btn-loading" aria-hidden="true">
                        <use xlink:href="#icon-v4_loading"></use>
                    </svg>
                </b-button>
            </div>
            <b-row>
                <b-col class="table-section">
                    <el-table :height="$store.state.baseData.tableH" class="table-container" :data="tableList"
                        @sort-change="sortChanged" :cell-class-name="addEnClass"
                        :default-sort="{ prop: 'walletBalance', order: 'descending' }">
                        <template slot="empty">
                            <load-skeleton v-show="loading" :columns="6" :rows="10"
                                :haveLeftNumber="false"></load-skeleton>
                            <h4 class="common-table-noData" v-show="!loading">
                                <img src="../../assets/images/v4_nodata.png" alt="" />
                                <div class="noData-text">
                                    {{ $t("common.noData") }}
                                </div>
                            </h4>
                        </template>

                        <!--  序号 -->
                        <el-table-column prop="sort" align="left" :label="$t('common.sort')">
                        </el-table-column>

                        <!--  uid-->
                        <el-table-column prop="uid" align="right" :label="$t('lanV4.newUid')">
                        </el-table-column>
                        <!--  pid -->
                        <el-table-column prop="pid" align="right">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        <!-- 直属上级UID -->
                                        {{ $t("lanV4.pidTip2") }}
                                    </div>
                                    <span> {{ $t("lanV4.PID") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <span class="enNum">
                                    {{ scope.row.pid }}
                                </span>
                            </template>
                        </el-table-column>
                        <!-- 返佣级别 -->
                        <!-- v-if="!disabledReturnLevel" -->
                        <el-table-column prop="levelName" :label="$t('lanV4.ReturnedCommissionLevel')" align="right">
                        </el-table-column>
                        <!-- 合约总资产-->
                        <el-table-column prop="info" align="right" :label="$t('lanV4.totalContracAssets')" width="200">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        <!-- 此时的合约账户中的资产，合约总资产 = 钱包余额 + 未实现盈亏 -->
                                        {{ $t("lanV4.totalContracAssetsTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.totalContracAssets") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <div>
                                    <div>{{ scope.row.totalBalance }}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <!-- 钱包余额-->
                        <el-table-column prop="walletBalance" align="right" :label="$t('lanV4.WalletBalance')"
                            sortable="'custom'" width="200">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        <!-- 此时合约账户的钱包余额，钱包余额 = 余额账户 + 逐仓保证金 + 冻结保证金 -->
                                        {{ $t("lanV4.WalletBalanceTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.WalletBalance") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <div>
                                    <div>{{ scope.row.walletBalance }}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <!-- 流入-->
                        <el-table-column prop="inflow" align="right" :label="$t('lanV4.agentInflow')"
                            sortable="'custom'">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        <!-- 在所选时间段内转入合约账户的资产 -->
                                        {{ $t("lanV4.agentInflowTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentInflow") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <div>
                                    <div>{{ scope.row.inflow }}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <!-- 流出-->
                        <el-table-column prop="outflow" align="right" :label="$t('lanV4.agentOutflow')"
                            sortable="'custom'">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        <!-- 在所选时间段内转出合约账户的资产 -->
                                        {{ $t("lanV4.agentOutflowTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentOutflow") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <div>
                                    <div>{{ scope.row.outflow }}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <!-- 收益-->
                        <el-table-column prop="profit" align="right" :label="$t('lanV4.agentIncome')"
                            sortable="'custom'">
                            <template slot-scope="scope" slot="header">
                                <el-tooltip placement="top">
                                    <div slot="content" style="max-width: 200px">
                                        <!-- 在所选时间段内合约账户的收益 -->
                                        {{ $t("lanV4.agentIncomeTip") }}
                                    </div>
                                    <span> {{ $t("lanV4.agentIncome") }}</span>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <div style="margin-right: 10px;">
                                    <div>{{ scope.row.profit }}</div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </b-col>
            </b-row>
            <b-row class="mar-t-20">
                <b-col>
                    <v-page v-if="pages.total > 0" :total-rows="pages.total" :perPage="pages.size"
                        :pageOptions="pages.options" :currentPage="pages.page" @initialize="pageChange"></v-page>
                </b-col>
            </b-row>
        </b-card>

        <!-- 导出10000条提示 -->
        <b-modal v-model="exportsModalShow" :title="$t('exportsModal.text1')" size="md" centered scrollable
            no-close-on-backdrop id="code-modal">
            <div class="body-content">
                <div class="expor-number-tip">
                    {{
                        $t("exportsModal.text2", { pagesTotal: pages.total, maxNum: exportNumLimit })
                    }}
                </div>
            </div>
            <template v-slot:modal-footer>
                <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
                        $t("common.cancel")
                    }}</b-button>
                <b-button class="coustom-btn" variant="primary" @click="exports('true')"
                    :class="!isexportIng ? 'lodingSattus' : ''">
                    <template v-if="!isexportIng">
                        {{ $t("common.exportIng") }}
                    </template>
                    <template v-else>
                        <!-- 继续导出 -->
                        {{ $t("exportsModal.text3") }}
                    </template>
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import commonMixin from "@/mixin/common/commonMixin";
import { fixD, fixInput, formatTime, formatTimeDay } from "@/apis/newmethods";
import headerUpdate from "./components/headerUpdate.vue";
export default {
    name: "agentUserAssets",
    mixins: [commonMixin],
    components: {
        headerUpdate,
    },
    data() {
        return {
            searchUid: null, // uid
            pid: null, //pid
            level: null, //返佣级别
            levelArray: [], //返佣级别下拉
            dateArray: [new Date().getTime() - 86400000 * 30, new Date().getTime() - 86400000 * 1],
            beginDate: null,
            endDate: null,
            beginDateTwo: null,
            endDateTwo: null,
            symbol: null,
            symbolList: [],
            // 当天之后的时间无法选择
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > window.Date.now()-8.64e7;
                },
            },

            pages: {
                page: 1, // 当前页数
                size: 10, // 页数大小
                options: [10, 40, 60, 100], // 页数大小选择
                total: 0, // 总页数
            },
            notData: true,
            loading: true,
            tableList: [],
            modalShow: false,
            isexportIng: true,
            sortBy: null, //预先排序的字段
            sortDesc: true, //预先降序
            sortName: "walletBalance", //默认排序字段
            sortSet: 1, //默认倒序
        };
    },
    computed: {
        exportButtonText() {
            if (!this.isexportIng) {
                return this.$t("common.exportIng"); // '正在导出'
            }
            return this.$t("common.export");
        },
    },
    watch: {
        pid(v) {
            if (v) {
                this.$nextTick(() => {
                    this.pid = fixInput(v, 0, { num: 1 });
                });
            }
        },
        searchUid(v) {
            if (v) {
                this.$nextTick(() => {
                    this.searchUid = fixInput(v, 0, { num: 1 });
                });
            }
        },
    },
    created() {
        this.getLastMonthOne()
        this.handleChangeDate();
        this.getReturnLevel();
        this.level = this.levelArray[0];
        this.getAgentSmbolList();

    },
    methods: {
        // 选择时间
        handleChangeDate() {
            this.beginDate = this.dateArray[0];
            this.endDate = this.dateArray[1];
        },
        // 英文数字字体
        addEnClass({ row, column }) {
            switch (column.property) {
                case "walletBalance":
                    return "enNum";
                case "inflow":
                    return "enNum";
                case "outflow":
                    return "enNum";
                case "profit":
                    return "profit";
            }
        },

        // 排序变化
        sortChanged(ctx) {
            switch (ctx.prop) {
                case "walletBalance":
                    this.sortName = "walletBalance";
                    break;
                case "inflow":
                    this.sortName = "inflow";
                    break;
                case "outflow":
                    this.sortName = "outflow";
                    break;
                case "profit":
                    this.sortName = "profit";
                    break;
            }
            if (ctx.order === "descending") {
                this.sortSet = 1;
            } else if (ctx.order === "ascending") {
                this.sortSet = 0;
            } else {
                this.sortSet = null;
                this.sortName = null;
            }
            this.getData();
        },

        // 获取返佣级别下拉
        getReturnLevel() {
            this.$http({
                url: this.$store.state.url.agent.level_list,
                params: {
                    hasSelfReturn: 0, //不包含自返佣
                },
            }).then(({ data, code, msg }) => {
                if (data && code.toString() === "0") {
                    let arr = [];
                    arr.push({ label: this.$t("common.all"), value: null });
                    if (data) {
                        data.levelArray.map((item) => {
                            arr.push({ label: item.levelName, value: item.level });
                        });
                        this.levelArray = arr;
                        this.level = arr[0];
                    }
                } else {
                    this.$bus.$emit("alert", { type: "error", message: msg });
                }
            });
        },

        // 获取经纪人保证金币种
        getAgentSmbolList() {
            //   let brokerId;
            //   if (this.brokerId && this.brokerId.value) {
            //     brokerId = this.brokerId.value;
            //   } else {
            //     brokerId = null;
            //   }
            this.$http({
                url: this.$store.state.url.agent.getMarginCoinList,
                params: {
                    companyId: null,
                },
            }).then(({ data, code, msg }) => {
                if (data && code.toString() === "0") {
                    // let arr = [{ label: this.$t("common.all"), value: null }];
                    let arr = [];
                    if (data.coinList.length) {
                        data.coinList.map((item) => {
                            if (this.roleType == 0 || this.roleType == 1) {
                // 平台商户展示otherName 传参coin
                arr.push({ label: item.otherName, value: item.coin });
              }
              if (this.roleType == 3 || this.roleType == 4) {
                // 经纪人展示otherName 传参coin
                arr.push({ label: item.otherName, value: item.coin });
              }
                        });
                    }
                    this.symbolList = arr;
                    this.symbol = this.symbolDefaultValue();
                    this.getData();
                } else {
                    this.$bus.$emit("alert", { type: "error", message: msg });
                }
            });
        },
        //获取保证金币种默认值
        symbolDefaultValue() {
            let data = [];
            if (this.symbolList && this.symbolList.length) {
                data = this.symbolList[0];
                this.symbolList.forEach((item) => {
                    if (item.value === "USDT") {
                        data = item;
                    }
                });
            }
            return data;
        },
        // 最近一月
        getLastMonthOne() {
            var end = new window.Date(new window.Date() - 1000 * 60 * 60 * 24);
            var year = end.getFullYear();
            var month = end.getMonth() + 1; //0-11表示1-12月
            var day = end.getDate();
            var dateObj = {};
            dateObj.end = year + "-" + month + "-" + day;
            var endMonthDay = new window.Date(year, month, 0).getDate(); //当前月的总天数
            if (month - 1 <= 0) {
                //如果是1月，年数往前推一年<br>
                dateObj.start = year - 1 + "-" + 12 + "-" + day;
            } else {
                var startMonthDay = new window.Date(
                    year,
                    parseInt(month) - 1,
                    0
                ).getDate();
                if (startMonthDay < day) {
                    //1个月前所在月的总天数小于现在的天日期
                    if (day < endMonthDay) {
                        //当前天日期小于当前月总天数
                        dateObj.start =
                            year +
                            "-" +
                            (month - 1) +
                            "-" +
                            (startMonthDay - (endMonthDay - day));
                    } else {
                        dateObj.start = year + "-" + (month - 1) + "-" + startMonthDay;
                    }
                } else {
                    dateObj.start = year + "-" + (month - 1) + "-" + day;
                }
            }
            this.beginDate = new window.Date(
                dateObj.start.replace(/-/g, "/")
            ).getTime();
            this.endDate = new window.Date(dateObj.end.replace(/-/g, "/")).getTime();

            this.dateType = 1;
            this.dateArray = [
                formatTimeDay(this.beginDate),
                formatTimeDay(this.endDate),
            ];
        },
        // 搜索
        query() {
            this.pages.page = 1;
            this.loading = true;
            this.getData();
        },
        // 重置
        reset() {
            this.searchUid = null;
            this.searchEmailPhone = null;
            this.pid = null;
            this.level = this.levelArray[0];
            this.getLastMonthOne();
            this.handleChangeDate();
            this.symbol = this.symbolDefaultValue();
        },
        // 获取数据列表
        getData() {
            this.loading = true;
            this.tableList = [];
            const paramsData = {
                startTime: this.dateArray
                    ? new window.Date(this.beginDate).getTime()
                    : null,
                endTime: this.dateArray
                    ? new window.Date(this.endDate).getTime()
                    : null,
                uid: this.searchUid,
                pid: this.pid,
                pageNum: this.pages.page,
                pageSize: this.pages.size,
                sortParam: this.sortName,
                sortSet: this.sortSet,
                isExport: 0,
                level: this.level ? this.level.value : null,
                coin: this.symbol ? this.symbol.value : null,
            };
            this.$http({
                // url: this.$store.state.url.agent.user_list,
                url: this.$store.state.url.agent.user_amount,
                params: paramsData,
                // method: "get",
                // apiType: "fe-json-server",
            })
                .then(({ data, code, msg }) => {
                    this.loading = false;
                    if (data && code.toString() === "0") {
                        this.setData(data.pageInfo);
                    } else {
                        this.$bus.$emit("alert", { type: "error", message: msg });
                    }
                })
                .catch((e) => {
                    this.loading = false;
                });
        },
        setData(datas) {
            const { total, rows } = datas;
            this.pages.total = total ? total : 0;
            let arr = [];
            if (rows && rows.length) {
                rows.map((item, index) => {
                    arr.push({
                        sort: (this.pages.page - 1) * this.pages.size + (index + 1), //序号
                        uid: item.uid,
                        pid: item.pid ? item.pid : '--',
                        levelName: item.levelName, //返佣级别
                        totalBalance: item.totalBalance,//合约总资产
                        walletBalance: item.walletBalance,//钱包余额
                        inflow: item.inflow,//流入
                        outflow: item.outflow,//流出
                        profit: item.profit,//收益
                    });
                });
            }
            if (arr.length === 0) {
                this.notData = true;
            }
            this.tableList = arr;
        },
        // 导出
        exports(istrue) {
            if (
                istrue !== "true" &&
                this.pages.total &&
                Number(this.pages.total) > this.exportNumLimit
            ) {
                this.exportsModalShow = true;
            } else {
                if (!this.isexportIng) return;
                this.isexportIng = false;
                const paramsData = {
                    startTime: this.dateArray
                        ? new window.Date(this.beginDate).getTime()
                        : null,
                    endTime: this.dateArray
                        ? new window.Date(this.endDate).getTime()
                        : null,
                    uid: this.searchUid,
                    pid: this.pid,
                    pageNum: this.pages.page,
                    pageSize: this.pages.size,
                    sortParam: this.sortName,
                    sortSet: this.sortSet,
                    level: this.level ? this.level.value : null,
                    pageNum: this.pages.page,
                    pageSize: this.exportNumLimit,
                    isExport: 1,
                    coin: this.symbol ? this.symbol.value : null,
                };

                this.outExcel(
                    this.$store.state.url.agent.user_amount,
                    paramsData,
                    "increment-api"
                ).then((datas) => {
                    if (datas.code === "0") {
                        this.$bus.$emit("alert", {
                            type: "success",
                            message: this.$t("common.exportSuccess"),
                        }); // 导出成功
                        this.exportsModalShow = false;
                        setTimeout(() => {
                            this.isexportIng = true;
                        }, 500);
                    } else {
                        this.$bus.$emit("alert", {
                            type: "error",
                            message: this.$t("common.exportError"),
                        }); // 导出失败
                    }
                });
            }
        },
        onReset() {
            this.exportsModalShow = false;
        },
        // 分页
        pageChange(data) {
            const { page, pageSize } = data;
            this.pages.page = page;
            this.pages.size = pageSize;
            const v = "page";
            this.getData(v);
        },
    },
};
</script>

<style lang="scss">
#agentUserAssets {
    .custom-control {
        top: 5px !important;
    }

    .el-table th.el-table__cell.is-leaf:last-child {
        padding-right: 0px !important;
    }
}
</style>